// extracted by mini-css-extract-plugin
export default {"cell":"vp_vo_Bq","input":"vp_rBC8S","alignRight":"vp_Y6LY1","alignCenter":"vp_GD04i","editMode":"vp_bqpG0"};